/** '@name', 'instagram.com/name/' or 'name' -> 'name'. */
export function cleanHandle(v: string): string {
  return (v || "")
    .trim()
    .replace(/^https?:\/\/(www\.)?instagram\.com\//i, "")
    .replace(/[/?#].*$/, "")
    .replace(/^@+/, "");
}

/** Any Indian mobile spelling ('+91 98…', '098…') -> its 10 digits. */
export function cleanPhone(v: string): string {
  let d = (v || "").replace(/\D/g, "");
  if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
  if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
  return d;
}
